/* eslint-disable */
export default {
  noRecords: 'Nenhum registo recente encontrado.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
